import Collection from 'lib/Collection';
import PotentialChatMember from 'entities/PotentialChatMember';

class PotentialChatMembers extends Collection<PotentialChatMember> {
  initialize() {
    this.url = '/chats/members/search/';
    // @ts-ignore - all the other Collections ignore this.
    this.model = PotentialChatMember;
  }

  getAvailableMembers() {
    return this.filterToCollection(member => !member.isUnavailable());
  }

  filterToCollection(filter: (pcm: PotentialChatMember) => boolean) {
    return new PotentialChatMembers(this.filter(filter));
  }

  parse(response: { potential_chat_members?: any }) {
    return response.potential_chat_members;
  }
}

export default PotentialChatMembers;
